import styles from "./LogoSection.module.css";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import parse from "html-react-parser";
import { useIsMobile } from "../../utils/utils";
import goatsTurkiz from "../../assest/home/goatsTurkiz.jpg";

interface RootState {
  links: {
    oliveTree: string;
    noTime: string;
  };
}

interface logoSectionProps {
  pageData: {
    homePageData: {
      no_time: string;
    };
  };
  loading: boolean;
}

const LogoSection: React.FC<logoSectionProps> = ({ pageData, loading }) => {
  const backgroundImage = useSelector(
    (state: RootState) => state.links.oliveTree
  );

  let text: React.ReactNode = (
    <Skeleton count={3} style={{ width: "300px", marginBottom: "10px" }} />
  );
  if (pageData) {
    text = <>{parse(pageData.homePageData.no_time)}</>;
  }
  const isMobile = useIsMobile();

  const logo = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="288.877"
      height="101.687"
      viewBox="0 0 288.877 101.687"
    >
      <g id="Group_1" data-name="Group 1" transform="translate(-816 -490)">
        <path
          id="Path_1"
          data-name="Path 1"
          d="M158.754,29.252l-7.678-9.113,10.147,1.277Zm-6.87,21.813-15.936-1.331L123.408,31.2,130.935,17.6l13.475,1.7,12.6,15.48-5.129,16.285M119.013,24.7l-6.357-9.4,11.237,1.414-4.88,7.982m20.825-11.015-6.271-.833,2.265-4.088,4.006,4.921M134.112,0l-7.307,11.955L101.551,8.6l14,21.754L103.739,49.686c1.9-.9,3.954-1.853,6.227-2.681a35.736,35.736,0,0,1,3.764-1.166q.87-.222,1.787-.393l4.508-8.14,5.364,8.333c.531.129,1.055.276,1.567.442a25.206,25.206,0,0,1,7.588,4.039,42.858,42.858,0,0,1,5.488,5.1c.9.977,1.74,1.947,2.543,2.9l6.928.5-1.742,5.532.315.353c2.751-1.481,7.29-3.931,9.628-5.2l.024-.09.126.009.837-.453,2.881-1.552,2.874-1.578q2.8-1.518,5.591-3.065l-10.309-.86,2.731-10.25,8.59,10.549,4.7-2.6-11.7-13.892,4.8-18-22.467-2.982L134.112,0"
          transform="translate(816 490)"
          fill="#ebf7f8"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M200.056,45.444q-.778,0-1.55.048a30.788,30.788,0,0,0-5.034.766,38.64,38.64,0,0,0-4.418,1.384c-1.365.527-2.638,1.094-3.843,1.672s-2.31,1.167-3.375,1.744L170.2,57.494q-2.869,1.6-5.759,3.158l-2.873,1.579-2.881,1.551q-3.187,1.728-6.361,3.427c.181.187.369.378.563.575.28.282.559.565.834.853l.994,1.023c.161.167.33.32.5.474s.3.284.455.428l2.034,1.921,3.167,2.745,3.228,2.561.04.032,2.719,1.975c.2.145.393.29.593.43l.753.5q2.041-.935,4.077-1.9,6.7-3.172,13.312-6.672Q188.8,70.43,192.01,68.7a39.46,39.46,0,0,1,5.168-2.4,10.755,10.755,0,0,1,3.458-.712h.1a7.589,7.589,0,0,1,3.011.718,20.366,20.366,0,0,1,4.228,2.628c.835.635,1.7,1.345,2.6,2.111.8.677,1.629,1.4,2.494,2.15l1.428,1.229,1.433,1.207c.869.718,1.743,1.457,2.618,2.2l5.346,4.612a123.589,123.589,0,0,0,11.759,9.2,59.581,59.581,0,0,0,13.642,6.912,53.748,53.748,0,0,0,7.139,1.949l.887.184.888.146,1.765.282c1.177.13,2.338.3,3.494.368q2.6.195,5.113.191a83.249,83.249,0,0,0,20.3-2.7l-.028-.615c-3.858-.7-7.653-1.4-11.35-2.242q-1.515-.343-3.008-.722c-7.333-1.812-14.506-4.414-20.644-8.427a49.731,49.731,0,0,1-4.471-3.232c-1.444-1.154-2.844-2.388-4.221-3.714-2.757-2.627-5.431-5.6-8.25-8.75-1.413-1.583-2.862-3.207-4.369-4.852-.76-.825-1.523-1.651-2.316-2.481-.766-.818-1.634-1.68-2.39-2.461-1.394-1.428-2.9-3.04-4.6-4.729a56.369,56.369,0,0,0-5.913-5.188,32.146,32.146,0,0,0-8.275-4.561,26.766,26.766,0,0,0-8.982-1.565"
          transform="translate(816 490)"
          fill="#ebf7f8"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M120.07,50.008a20.041,20.041,0,0,0-2.153.113,26.887,26.887,0,0,0-4.187.725,35.973,35.973,0,0,0-3.764,1.165c-2.381.868-4.517,1.871-6.5,2.81-15.41,7.359-30.96,14.309-46.2,20.732C43.564,81.355,30.115,86.665,17.4,91.607q-2.106.819-4.183,1.623-3.3,1.266-6.6,2.58Q3.3,97.088,0,98.456l.1.4q3.556-.32,7.1-.744,3.533-.462,7.063-.988A334.434,334.434,0,0,0,63.93,85.187c6.781-2.175,13.632-4.6,20.48-7.252q2.917-1.131,5.831-2.319c2.19-.911,4.392-1.808,6.578-2.755s4.378-1.9,6.553-2.895l3.258-1.5,3.225-1.5c1.412-.663,2.762-1.282,4.042-1.8.592-.239,1.169-.455,1.73-.643a15.76,15.76,0,0,1,4.76-.955c.1,0,.206,0,.31,0,.067,0,.134,0,.2,0l.493.039c.329.031.656.109.989.144a11.045,11.045,0,0,1,2,.666,14.043,14.043,0,0,1,1.436.747,20.728,20.728,0,0,1,2.854,2.069,63.2,63.2,0,0,1,4.55,4.391l2.415,2.52,1.276,1.306,1.337,1.282,1.337,1.275.667.634.695.6,2.775,2.386a99.909,99.909,0,0,0,11.774,8.2c1.026.583,2.062,1.141,3.085,1.7.516.275,1.017.57,1.543.822l1.572.756,1.567.745c.52.248,1.037.5,1.575.707l3.176,1.3c.521.223,1.061.406,1.6.587l1.606.546c1.067.36,2.119.73,3.207,1q1.612.429,3.21.858c1.077.237,2.16.439,3.225.651l1.593.307,1.609.2c1.069.129,2.122.271,3.174.372l3.153.146c.455.013.9.049,1.357.049l.2,0,1.549-.053c1.026-.045,2.037-.06,3.04-.142l2.972-.37c.489-.07.975-.113,1.455-.205l1.43-.313q1.408-.315,2.794-.63l-.052-.41a71.1,71.1,0,0,1-13.791-1.976c-1.308-.359-2.62-.684-3.921-1.093-.441-.138-.881-.286-1.319-.449-.865-.305-1.743-.557-2.6-.9l-2.574-1.041c-.426-.179-.862-.329-1.283-.531l-1.268-.6-2.537-1.191-2.494-1.333-1.25-.662-1.222-.734-2.453-1.459q-1.194-.792-2.4-1.586l-1.2-.79c-.394-.275-.779-.568-1.171-.85l-2.345-1.7-2.281-1.812-1.144-.906-1.106-.959-2.214-1.919-2.138-2.02c-.354-.339-.723-.662-1.065-1.015l-1.027-1.057c-.677-.712-1.392-1.39-2.044-2.126-1.314-1.479-2.617-2.889-3.93-4.5-1.333-1.6-2.737-3.3-4.322-5.017a42.878,42.878,0,0,0-5.489-5.1,25.209,25.209,0,0,0-7.587-4.038,22.686,22.686,0,0,0-6.886-1.08"
          transform="translate(816 490)"
          fill="#ebf7f8"
        />
      </g>
    </svg>
  );
  return (
    <div
      style={{ backgroundImage: `url(${goatsTurkiz})` }}
      className={styles.container}
    >
      <div className={styles.noTime}>
        <div className={styles.logo}>{logo}</div>
        <h1>תנועת מורשה</h1>
        <div className={styles.bodyText}>
          תנועת מורשה שמה לה למטרה לסייע ולתמוך בכל מי שעוסק בהתיישבות פורצת
          דרך, ולדחוף ולמשוך את ההתיישבות ועם ישראל כולו לעלות קומה אחר קומה, עד
          ליישוב ארץ ישראל השלמה על פי רצון ה'
        </div>
      </div>
    </div>
  );
};

export default LogoSection;
